import { DecimalPipe, NgTemplateOutlet } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { CardComponent } from '@sportello-balneari/shared-components';
import { EconomicOffer } from '../../../../../api/interfaces';

@Component({
  selector: 'lib-result-economic-offer-card',
  standalone: true,
  imports: [CardComponent, NgTemplateOutlet, DecimalPipe],
  templateUrl: './economic-offer-card.component.html',
})
export class ResultEconomicOfferCardComponent {
  economicOffer = input<EconomicOffer | null | undefined>();

  protected readonly scorePercent = computed(() => {
    const offer = this.economicOffer();
    if (offer?.score == null || !offer.maxScore) return null;
    return (offer.score / offer.maxScore) * 100;
  });

  protected readonly scoreBadgeClass = computed(() => {
    const pct = this.scorePercent();
    if (pct == null) return '';
    if (pct >= 80) return 'bg-green-100 text-green-700';
    if (pct >= 50) return 'bg-amber-100 text-amber-700';
    return 'bg-red-100 text-red-700';
  });
}
